<script setup lang="ts">
const props = defineProps<{
  attributes: {
    [x: string]: string
  }
  usps?: Array<unknown>
}>()

const maxDisplayedUsps = 4

const customUspsCount = computed(() => {
  const a = props.attributes || {}
  let count = 0
  if (a?.poo_warranty) count++
  if (a?.poo_self_assembly === 'Ja') count++
  // if (a.poo_is_custom_made) count++ // Doesn't count towards the limit since there is a fallback
  return count
})

const displayedUsps = computed(() => {
  if (!Array.isArray(props.usps)) return []
  const maxFromUsps = Math.max(0, maxDisplayedUsps - customUspsCount.value)
  return props.usps.slice(0, maxFromUsps)
})

const { loadIcon } = useDynamicIcons()
</script>

<template>
  <div>
    <div class="usps">
      <ul class="usps__list custom-usps">
        <li
          v-if="attributes?.poo_warranty"
          class="usps__item usp--warranty"
        >
          <Icon
            :name="loadIcon('star-hollow')"
            class="usps__icon usps__icon--star"
          />
          <span class="usps__label">
            {{ attributes.poo_warranty }}
          </span>
        </li>
        <li
          v-if="attributes?.poo_self_assembly === 'Ja'"
          class="usps__item usp--assembly"
        >
          <Icon
            :name="loadIcon('assembly')"
            class="usps__icon usps__icon--assembly"
          />
          <span class="usps__label">
            {{ $t('Self-assembly') }}
          </span>
        </li>
        <li
          v-if="attributes?.poo_is_custom_made === 'Ja'"
          class="usps__item usp--custom"
        >
          <Icon
            :name="loadIcon('tape-measure')"
            class="usps__icon usps__icon--tape-measure"
          />
          <span class="usps__label">
            {{ $t('Customisation possible') }}
          </span>
        </li>
        <li
          v-else
          class="usps__item usp--return"
        >
          <Icon
            :name="loadIcon('return')"
            class="usps__icon usps__icon--return"
          />
          <span class="usps__label">
            {{ $t('30 days return policy') }}
          </span>
        </li>
      </ul>
    </div>
    <AppUsps
      v-if="displayedUsps.length"
      :usps="displayedUsps"
      vertical
    />
  </div>
</template>

<style>
  @import url("~layers/app/components/Product/Usps.css");
</style>
